import React from "react";
import { Layout, Menu } from "antd";
import { BarChartOutlined, SettingOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";

const { Sider } = Layout;

interface SidebarProps {
  collapsed: boolean;
  onCollapse: (collapsed: boolean) => void;
}

const menuItems = [
  {
    key: "/",
    icon: <BarChartOutlined />,
    label: "Dashboard",
  },
  {
    key: "/settings",
    icon: <SettingOutlined />,
    label: "Settings",
  },
];

/**
 * Collapsible sidebar with navigation menu.
 * Uses React Router for navigation and highlights the active route.
 */
export function Sidebar({ collapsed, onCollapse }: SidebarProps): React.JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();

  // Match the active menu item to the current pathname.
  // For nested routes, find the deepest matching key.
  const selectedKey =
    menuItems
      .slice()
      .reverse()
      .find((item) =>
        item.key === "/"
          ? location.pathname === "/"
          : location.pathname.startsWith(item.key)
      )?.key ?? "/";

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={onCollapse}
      breakpoint="lg"
      width={220}
      collapsedWidth={64}
      style={{
        overflow: "auto",
        height: "100vh",
        position: "sticky",
        insetInlineStart: 0,
        top: 0,
        bottom: 0,
        scrollbarWidth: "thin",
      }}
    >
      {/* Logo / Brand area */}
      <div
        style={{
          height: 64,
          display: "flex",
          alignItems: "center",
          justifyContent: collapsed ? "center" : "flex-start",
          paddingInline: collapsed ? 0 : 20,
          fontSize: collapsed ? 20 : 16,
          fontWeight: 700,
          color: "rgba(255,255,255,0.85)",
          letterSpacing: collapsed ? 0 : 1,
          transition: "all 0.2s",
          whiteSpace: "nowrap",
          overflow: "hidden",
        }}
      >
        {collapsed ? "QB" : "QB Dashboard"}
      </div>

      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[selectedKey]}
        items={menuItems}
        onClick={({ key }) => navigate(key)}
        style={{ borderInlineEnd: "none" }}
      />
    </Sider>
  );
}
